import React, {StrictMode, Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import './i18n';
import Loader from './components/Common/Loader/Loader';
import { APP_VERSION } from './utils/version';

// Clear cache when version changes
(() => {
  const STORAGE_KEY = 'app_version';
  const storedVersion = localStorage.getItem(STORAGE_KEY);
  const currentVersion = APP_VERSION;
  
  if (storedVersion && storedVersion !== currentVersion) {
    console.log('New version detected, clearing cache...');
    
    // Clear all caches
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    
    // Clear localStorage (optional - comment out if you want to keep user data)
    // localStorage.clear();
    
    // Clear sessionStorage
    sessionStorage.clear();
    
    // Update stored version
    localStorage.setItem(STORAGE_KEY, currentVersion);
    
    // Force reload to get fresh content
    window.location.reload();
  } else if (!storedVersion) {
    // First time - store version
    localStorage.setItem(STORAGE_KEY, currentVersion);
  }
})();

ReactDOM.render(
    <StrictMode>
        <Provider store={store}>
            <Suspense fallback={<Loader isVisible={true}/>}>
                <App/>
            </Suspense>
        </Provider>
    </StrictMode>,
    document.getElementById('root')
);

reportWebVitals();
